<template>
  <div>
    <label
      :for="`scope-field-${kebabLabel}`"
      v-text="sentenceLabel"
    />
    <FlatPickr
      :id="`scope-field-${kebabLabel}`"
      :value="null"
      style="margin-bottom: 0;"
      @input="handleDateAdded"
    />
  </div>
</template>

<script type="text/babel">
import FlatPickr from 'vue-flatpickr-component'
import { kebabCase, startCase } from 'lodash'

export default {
  name: 'DateInput',
  components: {
    FlatPickr: FlatPickr,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
  },
  computed: {
    kebabLabel() {
      return kebabCase(this.label)
    },
    sentenceLabel() {
      return startCase(this.label)
    },
  },
  methods: {
    handleDateAdded(date) {
      this.$emit('dateAdded', {
        key: this.label,
        value: date,
      })
    },
  },
}
</script>

<style lang="scss">
.flatpickr-monthDropdown-months {
  border: none;
  font-size: 1rem;
  padding: 0;
  width: auto;

  &:focus {
    box-shadow: none;
  }
}
</style>
